import type { FC } from 'react';

import { SavedViewRow } from '../components/SavedViewRow';

export interface SavedViewNavRow {
  id: string;
  name: string;
  count?: number;
  loading?: boolean;
  active: boolean;
  onSelect: () => void;
}

export const SavedViewsNavSection: FC<{ rows: SavedViewNavRow[] }> = ({ rows }) => (
  <div className="mt-2 mb-4 pl-2">
    <p className="text-info-500 px-2 text-xs font-semibold tracking-wide uppercase">My Filtered Views</p>
    <div className="mt-1 space-y-1">
      {rows.map(({ id, name, count, loading, active, onSelect }) => (
        <SavedViewRow key={id} name={name} count={count} loading={loading} active={active} onClick={onSelect} />
      ))}
    </div>
  </div>
);
